var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS42(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 33.7499H7.50001C7.16849 33.7499 6.85054 33.6182 6.61612 33.3837C6.3817 33.1493 6.25001 32.8314 6.25001 32.4999V25.5155C6.24944 25.3532 6.28089 25.1923 6.34255 25.0422C6.40422 24.8921 6.49489 24.7555 6.60938 24.6405L25.3594 5.89049C25.4757 5.77238 25.6143 5.67859 25.7672 5.61457C25.9201 5.55055 26.0842 5.51758 26.25 5.51758C26.4158 5.51758 26.5799 5.55055 26.7328 5.61457C26.8857 5.67859 27.0243 5.77238 27.1406 5.89049L34.1094 12.8592C34.2275 12.9755 34.3213 13.1142 34.3853 13.2671C34.4493 13.42 34.4823 13.5841 34.4823 13.7499C34.4823 13.9156 34.4493 14.0797 34.3853 14.2326C34.3213 14.3855 34.2275 14.5242 34.1094 14.6405L15 33.7499Z",
    stroke: "#8D48E8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 10L30 18.75",
    stroke: "#8D48E8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 33.75H15L6.32812 25.0781",
    stroke: "#8D48E8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 14.375L10.625 29.375",
    stroke: "#8D48E8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS42);
export default __webpack_public_path__ + "static/media/s4-2.03948df0aae8acaf606020ebec5138f2.svg";
export { ForwardRef as ReactComponent };